import React from 'react';
import { Text } from '@oneaudi/unified-web-components';
import styled from 'styled-components';
import { useI18n } from '../i18n';
import type { DisplayedVehicleType } from '../utils/filterUtils';

interface ResultCountHeaderProps {
  hasActiveFilters: boolean;
  selectedVehicleType?: DisplayedVehicleType[];
  filteredCount: number;
}

export const ResultCountHeader: React.FC<ResultCountHeaderProps> = ({
  hasActiveFilters,
  selectedVehicleType,
  filteredCount,
}) => {
  let resultCount: string;

  if (hasActiveFilters) {
    resultCount = useI18n('resultCount');
  } else if (!selectedVehicleType || selectedVehicleType.length === 0) {
    resultCount = useI18n('vehicleType.ALL');
  } else if (
    selectedVehicleType.length === 1 &&
    ['BEV', 'PHEV', 'ICEV'].includes(selectedVehicleType[0])
  ) {
    resultCount = useI18n(`vehicleType.${selectedVehicleType[0]}`);
  } else {
    // TODO: check if we need additional i18n Keys for multi selection if drive-type
    resultCount = useI18n('vehicleType.ALL');
  }

  return (
    <CountWrapper>
      <Text
        variant={{
          order: process.env.IS_LEGACY ? '2' : '3',
          type: 'copy',
          style: 'normal',
        }}
        tag="span"
      >
        {resultCount}
      </Text>
      <StyledText
        variant={{
          order: process.env.IS_LEGACY ? '2' : '3',
          type: 'copy',
          style: 'normal',
        }}
      >{`(${filteredCount})`}</StyledText>
    </CountWrapper>
  );
};

const CountWrapper = styled.div`
  display: flex;
  align-items: baseline;
  padding-bottom: var(--spacing-relative-md);
  gap: var(--spacing-relative-2xs);
`;

const StyledText = styled(Text)`
  color: ${({ theme }) => theme.colors.filterCategoryUnselectedTextColor};
`;
